export const landingPageContent = {
  header: {
    links: [
      { id: 1, label: 'Home', link: '#' },
      { id: 2, label: 'Features', link: '#features' }
    ]
  },
  hero: {
    title: ['Transform Your Store', ' with Smart Image Uploads'],
    description:
      'Let your customers upload images directly on your product pages. Perfect for custom prints, engraving, personalized gifts, and more — no back-and-forth emails needed.'
  },
  features: {
    title: 'Everything You Need',
    description: 'Simple setup, powerful results for your store',
    items: [
      {
        id: 1,
        title: 'Your Rules, Automatic',
        content:
          'Define the image sizes, formats, and quality your products require. Customers see clear guidance upfront, so you get print-ready files every time.'
      },
      {
        id: 2,
        title: 'Images Attached to Orders',
        content:
          'Every uploaded image is linked directly to the order — no more digging through emails or shared drives. Just open the order and the file is right there.'
      },
      {
        id: 3,
        title: 'Fewer Support Tickets',
        content:
          'Customers get real-time feedback if their image is too small, wrong format, or low quality. They fix it themselves before checkout — saving you time.'
      },
      {
        id: 4,
        title: 'Built-in Image Editor',
        content:
          'Your customers can crop, resize, and adjust their images right on your store. Great for custom prints, phone cases, mugs, and any personalized product.'
      },
      {
        id: 5,
        title: 'Matches Your Store',
        content:
          'A clean, easy-to-use upload experience that integrates seamlessly with your store.'
      }
    ]
  },
  callToAction: {
    buttonText: 'Install Now',
    title: 'Ready to sell personalized products the easy way?',
    description:
      'Join our users and Shopify stores already using Akadenia Upload to increase customer satisfaction and reduce support overhead.'
  }
}
